export default __webpack_public_path__ + "static/media/CustomerSopport.3483575b.png";